import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight, Trophy, Target, Scale, Calendar, Star, Check, ArrowRight } from 'lucide-react';
import LeadForm from './LeadForm';

const features = [
  {
    icon: Target,
    title: 'Premium Facilities',
    description: 'World-class equipment and luxury amenities'
  }
];

export default function Hero() {
  return (
    <div className="relative min-h-[calc(100vh-4rem)] sm:min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-[url('https://i.ibb.co/FqcytVP5/DSC01317.jpg')] bg-cover bg-center opacity-20" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/70 to-black" />
      </div>

      <div className="relative z-10 w-full px-4 py-12 sm:py-0">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Left side - Hero content */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              className="text-center lg:text-left"
            >
              <h1 className="text-7xl font-bold mb-6">
                FITNESS
                <br />
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-cyan-400">
                  PORTAL
                </span>
              </h1>
              <p className="text-xl text-gray-400 mb-8">
                Experience Auckland's premier fitness destination with world-class facilities and expert guidance.
              </p>

              <div className="flex justify-center lg:justify-start mb-8">
                <div className="flex items-center space-x-4 bg-gradient-to-br from-blue-500/10 to-cyan-500/10 rounded-xl p-6 max-w-md">
                  <Target className="w-6 h-6 text-blue-400" />
                  <div>
                    <h4 className="font-bold">Premium Facilities</h4>
                    <p className="text-sm text-gray-400">World-class equipment and luxury amenities</p>
                  </div>
                </div>
              </div>

              <div className="flex flex-wrap justify-center lg:justify-start gap-4">
                <a
                  href="/memberships"
                  className="inline-flex items-center space-x-2 bg-gradient-to-r from-blue-600 to-cyan-600 text-white px-8 py-4 rounded-full font-bold hover:from-blue-700 hover:to-cyan-700 transition-all duration-300 group"
                >
                  <span>VIEW MEMBERSHIPS</span>
                  <ChevronRight className="w-5 h-5 transform group-hover:translate-x-1 transition-transform duration-300" />
                </a>
                <div className="flex items-center space-x-2 bg-gradient-to-r from-blue-500/20 to-cyan-500/20 backdrop-blur-sm rounded-full px-6 py-3">
                  <Check className="w-5 h-5 text-blue-400" />
                  <span>No Lock-in Contract</span>
                </div>
              </div>
            </motion.div>

            {/* Right side - Lead form */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3, duration: 0.8 }}
              className="w-full"
            >
              <LeadForm
                title="GET STARTED TODAY"
                subtitle="Join Auckland's premier fitness community"
                showPromo={false}
                ctaText="GET STARTED"
              />
            </motion.div>
          </div>
        </div>
      </div>
    </div>
  );
}